/**
 * Les conversations dont la suppression est EN VOL (#1334).
 *
 * Module volontairement nu : le registre est lu par le runtime documentaire
 * lui-même, au seam d'acquisition, et posé par le parcours de suppression qui
 * appelle ce runtime. Les garder dans un seul fichier ferait un cycle
 * d'imports ; la politique de suppression vit dans
 * `suppressionDeConversation.ts`, ce fichier n'en porte que le fait.
 *
 * Ensemble hors React, comme les fils confirmés de #1331 : ses lecteurs sont
 * des chemins qui ne sont pas montés dans l'assistant — un handler WebSocket,
 * la commande d'ouverture d'une grille de dossier — et un `useState` n'y serait
 * lisible de personne.
 */

const filsEnSuppression = new Set<string>();

/**
 * Ouvre la fenêtre de suppression d'un fil.
 *
 * ⚠️ **Posé AVANT le DELETE réseau**, jamais après : entre l'appel et sa
 * réponse il y a des centaines de millisecondes pendant lesquelles un
 * `redaction_job_started` ou un geste d'ouverture peut acquérir une session
 * documentaire sur ce fil — et ressusciter ce qu'on vient de retirer.
 * Idempotent : marquer deux fois le même fil ne change rien.
 */
export function marquerLaSuppressionEnCours(conversationId: string): void {
  filsEnSuppression.add(conversationId);
}

/** Levé sur ÉCHEC du DELETE : le fil et son document sont conservés. */
export function leverLaSuppressionEnCours(conversationId: string): void {
  filsEnSuppression.delete(conversationId);
}

/**
 * Ce fil est-il dans sa fenêtre de suppression ?
 *
 * Lu au seam d'acquisition du runtime documentaire — le seul endroit par lequel
 * passent les six entrées agent, le geste humain d'ouverture et la restauration
 * d'un brouillon — et par `ouvrirLeCanvasPourLAvocat`, qui rend `null` plutôt
 * que de laisser lever un `onClick` sans `try/catch`.
 *
 * @param conversationId `null` accepté et toujours faux : un écran sans
 * conversation affichée n'est pas un fil en cours de suppression, et faire
 * porter ce test à chaque appelant garantirait qu'un l'oublie.
 */
export function estEnCoursDeSuppression(conversationId: string | null): boolean {
  return conversationId !== null && filsEnSuppression.has(conversationId);
}

/** Purge du changement de compte : aucune fenêtre de suppression ne survit. */
export function oublierLesSuppressionsEnCours(): void {
  filsEnSuppression.clear();
}
